import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt';

class BillingItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  deleteItem = (id) => {
    this.props.deleteBillingItem(id);
  };

  render() {
    const { billingItem } = this.props;
    const price = Number(billingItem.pricePerQty) / 100.0;
    return (
      <tr>
        <td>{billingItem.itemName}</td>
        <td>{billingItem.itemDesc}</td>
        <td>{billingItem.itemQty}</td>
        <td>${price.toFixed(2)}</td>
        <td className={'text-center'}>
          <FontAwesomeIcon
            icon={faTrashAlt}
            size="1x"
            onClick={() => {
              this.deleteItem(billingItem.id);
            }}
          />
        </td>
      </tr>
    );
  }
}

BillingItem.propTypes = {
  billingItem: PropTypes.object,
  deleteItem: PropTypes.func,
};

export default BillingItem;



// WEBPACK FOOTER //
// ./src/components/repair-log/BillingItem.js